"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Browser_1 = require("../utils/Browser");
var isCtrlOrMetaPressedImpl = Browser_1.Browser.isMac
    ? function (event) { return event.metaKey; }
    : function (event) { return event.ctrlKey; };
/**
 * Check if Ctrl key (Windows) or Meta key (Mac) is pressed for the given Event
 * @param event A Keyboard event or Mouse event object
 * @returns True if Ctrl key is pressed on Windows or Meta key is pressed on Mac
 */
function isCtrlOrMetaPressed(event) {
    return isCtrlOrMetaPressedImpl(event);
}
exports.default = isCtrlOrMetaPressed;
//# sourceMappingURL=isCtrlOrMetaPressed.js.map